import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};


// helper: inject subTenantId into request body if exists
const injectSubTenantId = (data) => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
        const jsonData = JSON.parse(data);
        jsonData.subTenantDTO = { id: decodedToken.subTenantId };
        return JSON.stringify(jsonData);
    }
    return data;
};

// helper: construct headers dynamically
const constructHeaders = () => {
    const headers = {
        Authorization: `Bearer ${token}`,
        "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };

    if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
        headers["tenant-login"] = true;
    }

    return headers;
};

const AftreCookApi = {
    // Create afterCook API
    CreateAftreCook: (data) => {
        data = injectSubTenantId(data);
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .post(`/afterCook`, data, { headers })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },

    // List afterCook API
    ListafterCook: (page, limit) => {
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .get(
                    `/afterCook?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    { headers }
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },

    // Update afterCook API
    UpdateafterCook: (afterCookID, data) => {
        data = injectSubTenantId(data);
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .put(`/afterCook/${afterCookID}`, data, { headers })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },

    // Single afterCook API
    SingleafterCook: (afterCookID) => {
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .get(
                    `/afterCook/${afterCookID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    { headers }
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },

    // Delete afterCook API
    DeleteafterCook: (afterCookID) => {
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .delete(
                    `/afterCook/${afterCookID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    { headers }
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },
};

export default AftreCookApi;
